import {Outlet, useNavigate} from 'react-router-dom';
import { useEffect } from 'react';
import './css/index.css';
import Header from './components/Header';
import Footer from './components/Footer';

const Layout = () =>{
    const navigate = useNavigate();

    useEffect(()=> {
        const user = localStorage.getItem('user');
        if(!user){
            navigate('/');
        }

        fetch('/api/users/verify', {credentials: 'include'})
            .then(res => {
                if(!res.ok){
                    localStorage.removeItem('user');
                    navigate('/');
                }
            })
            .catch(()=> {
                localStorage.removeItem('user');
                navigate('/');
            });
    }, [navigate]);

    return (
        <div>
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
};

export default Layout;